import script from "./SchoolsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolsTable.vue?vue&type=script&setup=true&lang=ts"

import "./SchoolsTable.vue?vue&type=style&index=0&id=6c17363a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c17363a"]])

export default __exports__